import { api } from '~/trpc-extra/api';
import type { OperationParentContext } from '~/server/logic/steps/operation/types';
import { useUpdateStepDescription } from '~/hooks/mutations/steps/useUpdateStepDescription';
import { notifications } from '@mantine/notifications';

export const useUpsertOperation = ({
  testContentId,
  stepId,
  parentContext,
  onMutate,
}: {
  testContentId: string;
  stepId: string;
  parentContext?: OperationParentContext;
  onMutate?: () => void;
}) => {
  const trpcUtils = api.useUtils();
  const { updateStepDescription } = useUpdateStepDescription({ testContentId });

  return api.operation.upsertOperation.useMutation({
    onMutate: () => {
      onMutate?.();
    },
    onSettled: async () => {
      if (parentContext?.conditional) {
        void trpcUtils.operation.getFullConditionalBlock.invalidate({
          conditionalBlockId: parentContext.conditional.conditionalBlockId,
        });
      } else if (parentContext?.componentId) {
        void trpcUtils.component.get.invalidate({ id: parentContext.componentId });
      } else {
        void trpcUtils.testContent.get.invalidate({ id: testContentId });
      }
      await updateStepDescription({ stepId });
    },
    onError: (error) => {
      console.error(error);
      notifications.show({
        title: 'Error saving operation',
        message: 'Failed to save operation, please try again',
        color: 'red',
      });
    },
  });
};
